import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { FieldType } from 'onefaceui-react-components';
import { getResourceTo } from './utils';

const mapGMSFields = {
  LOOKUP: FieldType.LOOKUP,
  TEXT: FieldType.TEXT,
  PHONE: FieldType.TEXT,
  PICKLIST: FieldType.SELECT,
  TIME_MINUTES_SECONDS: FieldType.TIME,
  LAT_LONG: FieldType.TEXT,
  MILES_OR_METERS: FieldType.TEXT,
  PICKLIST_MULTISELECT: FieldType.SELECT,
  CHECKBOX: FieldType.CHECKBOX,
  DECIMAL: FieldType.DECIMAL,
  DATE_TIME: FieldType.DATETIME,
  COLOR: FieldType.COLOR,
  TAG: FieldType.MULTIPLE_SELECT
};

export const mapGMSField = async (item) => {
  const type = mapGMSFields?.[item.type] ?? FieldType.TEXT;

  const field = {
    id: item.id,
    label: getResourceTo(item.label),
    name: item.name,
    type
  };

  if (
    type === FieldType.LOOKUP &&
    item.lookupEntityColumn &&
    item.lookupEntity
  ) {
    Object.assign(field, {
      lookupParams: {
        entity: item.lookupEntity.key,
        column: item.lookupEntityColumn
      }
    });
  }

  if (['PICKLIST', 'PICKLIST_MULTISELECT'].includes(item.type)) {
    Object.assign(field, {
      extra: {
        getAsyncOptions: async () => {
          const response = await defaultFetch(`Field/${item.id}/FindDomains`);

          const options = response.map((option) => ({
            label: getResourceTo(option.description),
            value: option.value
          }));

          return options;
        },
        menuPosition: 'absolute'
      }
    });
  }

  if (item.type === 'TAG') {
    Object.assign(field, {
      extra: {
        onRequestData: async () => {
          const criteria = '{"filters":["*"]}';
          const payload = {
            criteriaChain: [
              {
                or: [
                  {
                    attr: 'tagType',
                    eq: 'EQUIPMENT'
                  }
                ]
              }
            ]
          };

          const url = `/Tag/restrictions?criteria=${encodeURI(
            criteria
          )}`;
          const response = await defaultFetch(url, payload, 'POST');

          const options = response.map((option) => ({
            label: option.description,
            value: option.id
          }));

          return options;
        }
      }
    });
  }

  return field;
};

export const mapGMSFieldsToColumns = (item) => {
  const field = mapGMSField(item);

  return {
    title: field.label,
    field: field.name,
    resizable: true,
    minWidth: 150,
    formatter: (cell) => {
      const value = cell.getValue();

      if (value && field.type === FieldType.LOOKUP && field.lookupParams) {
        const lookupEntityColumn = field.lookupParams.column;

        return value[lookupEntityColumn];
      }

      return value;
    }
  };
};
